module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.e610bc48.woff2";